export const createTimeLine = (fromTime: Date, toTime: Date, interval: number) => {
  const minutes = (+toTime - +fromTime) / 1000 / 60;
  const start = fromTime;
  const timeline: String[] = [];
  const iterations = Math.ceil(minutes / interval);

  for (let i = 0; i <= iterations; i++) {
    if (i !== 0) {
      start.setMinutes(start.getMinutes() + interval);
    }
    timeline.push(start.toString());
  }
  return timeline;
};

export const leadingZero = (i: number) => (i < 10 ? `0${i}` : i);

export const formatTime = (time: Date) =>
  `${leadingZero(time.getHours())}:${leadingZero(time.getMinutes())}`;
